import React from 'react';
import {Flex} from '/app/src/component';
import style from './style.css';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';

class PricingPlan extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            buttonHover: false,
            hover: false
        }

        this._handleButtonHover = this._handleButtonHover.bind(this)
        this._handleButtonLeave = this._handleButtonLeave.bind(this)
    }

    _hoverText(isActive, hoverText) {
        if (isActive) return "Ändra"

        return hoverText
    }

    _hoverBody(color, isActive, hoverText, hoverIcon) {
        const upgradeButtonStyle = {
            fontSize: '40px',
            position: 'absolute',
            height: '620px',
            fontWeight: 600,
            color: color,
            opacity: `${this.state.hover ? '1' : '0'}`,
            transition: 'opacity 0.1s'
        }

        return (
            <Flex className={style.UpgradeButton}
            {...upgradeButtonStyle}
            center column>
                <Flex hAlignContent='center'>
                    <SVG src={ isActive ? '/images/Settings_M.svg' : hoverIcon }
                    style={{fill: color, height:'60px', width:'60px'}}/>
                </Flex>
                <Flex>
                    {this._hoverText(isActive, hoverText)}
                </Flex>
            </Flex>
        )
    }


    render() {
        const {plan, isActive, onClick, hoverText, hoverIcon} = this.props;
        let price;
        let color;
        let icon;
        let featureList = []
        let yearlyPrice = null
        let imgSrc= ''
        switch(plan){
            case 'Start':
                price = '249kr'
                yearlyPrice = '229'
                color = '#2ea2d2'
                icon = '/images/ResolveButtonBlue.png'
                featureList = [
                    'Skräddarsy besökarnas upplevelse med styling, välkomstmeddelande och formulär.',
                    'Effektivisera arbetsflödet med mobilapp, automatiska offlineinställningar och förberedda snabbsvar.',
                    'Avlasta kundtjänsten med vanliga frågor och svar.'
                ]
                imgSrc = '/images/PriceplanGraphic_Start.png'
            break;
            case 'Pro':
            default:
                price = '349kr'
                yearlyPrice = '329'
                color = '#a25cbf'
                icon = '/images/ResolveButtonPurple.png'
                featureList = [
                    'Alla smidiga funktioner som Start innehåller.',
                    'Utvärdera och optimera er service med utökad statistik.',
                    'Effektivisera och avlasta genom att bygga en helpdesk och följ prestation med feedbacksystemet.',
                    'Håll er synkade med gruppchatt.',
                    'Utökad fil- och datakapacitet.'
                ]
                imgSrc = '/images/WelcomeGraphic_PRO.png'
            break;
        }

        const wrapper = {
            filter: `blur(${this.state.hover ? '15' : '0'}px)`,
            transition: 'filter 0.1s'
        }

        return(
            <Flex
            column grow>
                <Flex hAlignContent='center'>
                    <img className={style.PricingImage} alt='' src={imgSrc}/>
                </Flex>
                <Flex
                className={isActive ? style.ExtraBorder :  null}
                grow onClick={onClick}
                onMouseEnter={() => this.setState({hover:true})}
                onMouseLeave={() => this.setState({hover:false})}>
                    <Flex
                    hAlignContent='center'
                    column className={style.Container}
                    style={{borderColor: color}} grow>
                        {this._hoverBody(color, isActive, hoverText, hoverIcon)}
                        <Flex
                        {...wrapper}
                        grow column
                        hAlignContent='center'>
                            {this._renderHeaderText(plan, color)}
                            <Flex width='95%' className={style.HeaderLine} style={{borderColor: color}}/>
                            {this._renderYearlyPrice(yearlyPrice, color)}
                            {this._renderPriceText(price, color)}
                            {this._renderFeatureText(plan, icon, color, featureList)}
                        </Flex>
                    </Flex>
                </Flex>
                {this._renderCurrentPlan(isActive)}
            </Flex>
        );
    }

    _renderCurrentPlan(isActive) {
        const isActiveContainer = {
            hAlignContent: 'center',
            width: '100%',
            marginTop: '20px',
            height: '50px',
        }

        const isActiveStyle = {
            backgroundColor: 'LightBlue1',
            fontSize: '22px',
            border: '2px solid #2EA2D2',
            width: '80%',
            borderRadius: '25px',
            color: 'JibberBlue_M',
            fontWeight: 500
        }
        return (
            <Flex {...isActiveContainer}>
                {isActive && <Flex {...isActiveStyle} center>
                    Nuvarande Plan
                </Flex>}
            </Flex>
        )
    }

    _renderYearlyPrice(yearlyPrice, color) {
        const yearlyPriceStyle = {
            fontWeight: 500,
            fontStyle: 'italic',
            hAlignContent: 'center',
            color: color,
            fontSize: '16px',
            marginTop: '15px'
        }

        return (
            <Flex {...yearlyPriceStyle}>
                {yearlyPrice}kr per användare/månad vid årsavtal!
            </Flex>
        )
    }

    _renderHeaderText(plan, color){
        return (
            <Flex className={style.HeaderText} style={{color: color}}>
            {plan}
            </Flex>
        );
    }

    _renderPriceText(price, color){
        return(
            <Flex column hAlignContent='center'>
                <Flex className={style.PriceText} style={{color: color}}>
                    {price}
                    <Flex className={style.ExMomsText}>
                        &nbsp; ex. moms
                    </Flex>
                </Flex>
                <Flex className={style.PerUserText} marginTop='-15px'>
                    per användare / månad
                </Flex>
                <Flex className={style.NoSubscribtion} color='MediumGray4' >
                    Ingen Bindingstid.
                </Flex>
            </Flex>
        );
    }

    _renderFeatureText(plan, icon, color, featureList){
        return(
            <Flex column hAlignContent='center' className={style.FeatureText} grow>
                <Flex column marginTop='15px' shrink={0}>
                    {this._renderFeatureList(icon, color, featureList)}
                </Flex>
                <Flex className={style.EndText} vAlignContent='bottom' grow>
                    Gratis de första 14 dagarna.
                </Flex>
            </Flex>
        )
    }

    _renderFeatureList(icon, color, featureList){
        const iconStyle = {
            width: '20px',
            height: '20px'
        }
        const ListComponents = [];
        featureList.forEach((features, key) => {
            ListComponents.push(
                <Flex key={key} className={style.FeatureStyle}>
                    <Flex basis='25px'>
                        <img src={icon} alt='icon' style={iconStyle}/>
                    </Flex>
                    <Flex marginLeft='15px' color={color} grow>
                        {features}
                    </Flex>
                </Flex>
            )
        })

        return ListComponents;
    }

    _renderButton(color, buttonText){
        const {onClick} = this.props
        let backgroundColor;
        let textColor;
        if(this.state.buttonHover){
            backgroundColor = color;
            textColor = '#ffffff'
        }else{
            backgroundColor = '#ffffff';
            textColor = color;
        }

        return(
            <Flex className={style.ButtonWrapper}
                hAlignContent='center'
                marginTop='20px'
                onMouseOver={this._handleButtonHover}
                onMouseLeave={this._handleButtonLeave}>
                <Flex vAlignContent='bottom'>
                <button className={style.ButtonStyle}
                    style={{backgroundColor: backgroundColor, color: textColor, borderColor: color,}}
                    onClick={onClick}>
                    {buttonText}
                </button>
                </Flex>
                {/*<Flex className={style.PricingButton} style={{backgroundColor: backgroundColor, color: textColor, borderColor: color, border: '3px solid'}} marginTop='auto' vAlignContent='center' hAlignContent='center' >
                    {buttonText}
                </Flex>*/}
            </Flex>
        );
    }

    _handleButtonHover(){

        this.setState({
            buttonHover: true
        })
    }

    _handleButtonLeave(){
        this.setState({
            buttonHover: false
        })
    }

}

/**
*   plan: name for the plan, should be either Standard or Premium.
*/
PricingPlan.propTypes = {
  plan: PropTypes.oneOf(['Start', 'Pro']).isRequired,
};

export default PricingPlan;



// WEBPACK FOOTER //
// ./src/container/Company/PricingPlan/index.js